import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiPaginationUtil } from 'ng-jhipster';

import { UserRouteAccessService } from '../../../services';
import { UsersComponent } from './users.component';
import { UserDetailsComponent } from './user-details.component';
import { UserCreateComponent } from './user-create.component';
import { UserDeleteComponent, UserDeletePopupComponent } from './user-delete.component';
import { UserEditComponent } from './user-edit.component';

@Injectable()
export class UserResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: JhiPaginationUtil) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const USERS_ROUTES: Routes = [
    {
        path: 'users',
        redirectTo: 'users/user',
        resolve: {
            'pagingParams': UserResolvePagingParams
        },
        pathMatch: 'full'
    },
    {
        path: 'users/superadmin',
        component: UsersComponent,
        resolve: {
            'pagingParams': UserResolvePagingParams
        },
        data: {
            pageTitle: 'user.home.title',
            role: 'super_admin',
            authorities: ['ROLE_STAFF']
        },
        canActivate: [UserRouteAccessService],
    },
    {
        path: 'users/admin',
        component: UsersComponent,
        resolve: {
            'pagingParams': UserResolvePagingParams
        },
        data: {
            pageTitle: 'user.home.title',
            role: 'admin',
            authorities: ['ROLE_STAFF']
        },
        canActivate: [UserRouteAccessService],
    },
    {
        path: 'users/staff',
        component: UsersComponent,
        resolve: {
            'pagingParams': UserResolvePagingParams
        },
        data: {
            pageTitle: 'user.home.title',
            role: 'staff',
            authorities: ['ROLE_STAFF']
        },
        canActivate: [UserRouteAccessService],
    },
    {
        path: 'users/user',
        component: UsersComponent,
        resolve: {
            'pagingParams': UserResolvePagingParams
        },
        data: {
            pageTitle: 'user.home.title',
            role: 'user',
            authorities: ['ROLE_STAFF']
        },
        canActivate: [UserRouteAccessService],
    },
    {
        path: 'users/details/:username',
        component: UserDetailsComponent,
        data: {
            pageTitle: 'user.details.title',
            authorities: ['ROLE_STAFF']
        },
        canActivate: [UserRouteAccessService],
    },
    {
        path: 'users/edit/:username',
        component: UserEditComponent,
        data: {
            pageTitle: 'user.edit.title',
            authorities: ['ROLE_ADMIN']
        },
        canActivate: [UserRouteAccessService],
    },
    {
        path: 'users/create',
        component: UserCreateComponent,
        data: {
            pageTitle: 'user.create.title',
            authorities: ['ROLE_STAFF']
        },
        canActivate: [UserRouteAccessService],
    }
];

export const USERS_POPUPS_ROUTES: Routes = [
    {
        path: 'management/users/delete/:login',
        component: UserDeletePopupComponent,
        data: {
            authorities: ['ROLE_ADMIN'],
            pageTitle: 'user.title.main',
            modalComponent: UserDeleteComponent
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/users/users.route.ts